import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "is-flex headerSection" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "pb-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { class: "viewAllButton" }, "View All", -1)

import { PartnerOffer } from '@/features/partnerOffers/model';
import OffersList from './OffersList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OffersCategory',
  props: {
    title: null,
    description: null,
    offers: null,
    viewAllLink: null,
    context: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", null, _toDisplayString(__props.title), 1),
        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.description), 1)
      ]),
      _hoisted_3,
      (__props.viewAllLink)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: __props.viewAllLink,
              class: "viewAllButtonWrapper"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(OffersList, {
      class: "pt-3",
      offers: __props.offers,
      context: __props.context
    }, null, 8, ["offers", "context"])
  ]))
}
}

})